module.exports = __webpack_public_path__ + "assets/9cb226e66ed18890a2201d9237244cd8-DSC_0743.jpg";